import Base from '@app2/models/Base';
import File from "@app2/models/File";
import Tag from "@app2/models/Tag";
import Segment from "@app2/models/Segment";
import MediaPlaylist from "@app2/models/FilePlaylist";
import {renderedString} from "@app2/utils/helpers";
import get from "lodash/get";

export default class Playlist extends Base {
  static entity = 'App\\Playlist';

  static apiConfig = {
    baseURL: '/api/internal/v2/playlists/',
    actions: {
      fetch: {
        url: '/',
        dataKey: 'data',
      },
      uploadThumbnail(playlist, thumbnail) {
        const form = new FormData();
        form.append('thumbnail', thumbnail);
        return this.post(`${playlist}/thumbnail`, form)
      },
      removeThumbnail(playlist) {
        return this.delete(`${playlist}/thumbnail`);
      },
      duplicate({ hash, title, files_processed_count = 0 }) {
        return this.post(`${hash}/duplicate`, { title })
          .then(res => {
            Playlist.update({
              where: res.response.data.hash,
              data: { files_processed_count }
            })
            return res
          })
      },
      getPublicPlaylists(params = {}) {
        return this.get('', {
          params: {
            'filter[hub_id]': false,
            ...params,
          },
        })
      }
    }
  };

  watchFields = ['title', 'description', 'meta', 'sort', 'showAttachments', 'attachments', 'tags', 'thumbnail', 'privacy'];
  requiredFields = ['title', 'hub_id'];

  static fields() {
    return {
      id: this.attr(null),
      hash: this.attr(null),
      team: this.attr(null),
      team_id: this.attr(null),
      user_id: this.attr(null),
      hub_id: this.attr(null),
      title: this.attr(null),
      description: this.attr(null),
      sort: this.attr(null),
      files: this.attr([]) || this.belongsToMany(File, MediaPlaylist, 'playlist_id', 'file_id'),
      startTime: this.attr(-1),
      autoplay: this.attr(false),
      order: this.attr(false),
      useDefault: this.attr(false),
      meta: this.attr(null),
      privacy: this.attr(null),
      video_count: this.attr(null),
      audio_count: this.attr(null),
      total_files_processed_duration: this.attr(null),
      attachable_count: this.attr(null),
      files_processed_count: this.attr(null),
      files_unprocessed_count: this.attr(null),
      thumbnail: this.attr(null),
      first_file_meta: this.attr(null),
      disabled: this.attr(null),
      permissions: this.attr(null),
      sections: this.attr(null),
      segments: this.attr([]),
      attachments: this.attr([]),
      folders_count: this.attr(null),
      tags_count: this.attr(null),
      showAttachments: this.attr(null),
      tags: this.hasMany(Tag, 'playlist_hash', 'hash'),
      index_tags: this.attr(null),
      scheduled_at: this.attr(null),
      files_count: this.attr(null),
      files_failed_count: this.attr(null),
      ...super.fields(),
    };
  }

  static mutators() {
    return {
      meta(value) {
        if (!value || Array.isArray(value)) return {};
        return value;
      },
      description(value) {
        if (!value) return '';
        return value;
      },
      sort(value) {
        if (!value) return 'position';
        return value;
      },
    };
  }
  get lowerTitle() {
    return (this.title) ? this.title.toLowerCase() : '';
  }

  get renderedTitle() {
    return renderedString(get(this, 'title', null))
  }

  get automationsCount() {
    return this.folders_count + this.tags_count;
  }

  static setSegments(model) {
    if ( Array.isArray(model.segments) ) {
      model.segments.forEach(segment => {
        Segment.insertOrUpdate({data: segment});
      });
    }
  }

  static afterCreate(model) {
    Playlist.setSegments(model);
  }
}
